<template>
  <div class="media-lib-content">
    <bs-tabs v-model="selectedTab" vertical
             :fill="true"
             align="start"
             content-class="ml-tab-content"
             active-nav-item-class="ml-active-nav"
             active-tab-class="ml-active-tab"
             nav-wrapper-class="ml-media-tabs">
      <bs-tab>
        <template v-slot:title>
          <div class="tab-title">
            <em class="icon icon-images2"></em>
            <span class="tab-title-text">Image</span>
          </div>
        </template>
        <div class="row m-0 h-100 tab-content-media">
          <div class="col">
            <div class="row">
              <div class="col col-img" v-for="file in imageFiles" :key="file._id"
                @click="selectFile(file)" :class="{ 'selected': selectedFileId === file._id }">
                <div class="delete-btn" @click="confirmDeleteFile(file)">
                  <font-awesome-icon icon="times"></font-awesome-icon>
                </div>
                <img class="preview" :style="getBackgroundImage(file.result.thumbnailUrl)">
              </div>
            </div>
            <div class="load-more"
                 v-if="!loading && !loadingMore && currentPage < totalPage"
                 @click="loadMore">
              Load more ({{remainingItem}})
            </div>
            <div class="loading-more" v-if="loadingMore">Loading ... </div>
            <div class="center-message" v-if="loading">
              <b-spinner variant="primary" label="Spinning"></b-spinner>
            </div>
            <div class="center-message"  v-else-if="!imageFiles || imageFiles.length === 0">
              No data
            </div>
          </div>
        </div>
      </bs-tab>
      <bs-tab>
        <template v-slot:title>
          <div class="tab-title">
            <em class="icon icon-film4"></em>
            <span class="tab-title-text">Video</span>
          </div>
        </template>
        <div class="row m-0 h-100 tab-content-media">
          <div class="col">
            <div class="row">
              <div class="col col-img" v-for="file in videoFiles" :key="file._id"
                   @click="selectFile(file)" :class="{ 'selected': selectedFileId === file._id }">
                <div class="delete-btn" @click="confirmDeleteFile(file)">
                  <font-awesome-icon icon="times"></font-awesome-icon>
                </div>
                <img class="preview" :style="getBackgroundImage(file.result.thumbnailUrl)">
              </div>
            </div>
            <div class="center-message" v-if="loading">
              <b-spinner variant="primary" label="Spinning"></b-spinner>
            </div>
            <div class="center-message"  v-else-if="!videoFiles || videoFiles.length === 0">
              No data
            </div>
          </div>
        </div>
      </bs-tab>
      <bs-tab>
        <template v-slot:title>
          <div class="tab-title">
            <em class="icon icon-volume-high"></em>
            <span class="tab-title-text">Audio</span>
          </div>
        </template>
        <div class="row m-0 h-100 tab-content-media">
          <div class="col">
            <div class="row">
              <div class="col col-file" v-for="file in audioFiles" :key="file._id"
                   @click="selectFile(file)" :class="{ 'selected': selectedFileId === file._id }">
                <div class="delete-btn" @click="confirmDeleteFile(file)">
                  <font-awesome-icon icon="times"></font-awesome-icon>
                </div>
                <span class="text-box">{{file.originalName}}</span>
              </div>
            </div>
            <div class="center-message" v-if="loading">
              <b-spinner variant="primary" label="Spinning"></b-spinner>
            </div>
            <div class="center-message"  v-else-if="!audioFiles || audioFiles.length === 0">
              No data
            </div>
          </div>
        </div>
      </bs-tab>
      <bs-tab>
        <template v-slot:title>
          <div class="tab-title">
            <em class="icon icon-file-text"></em>
            <span class="tab-title-text">Others</span>
          </div>
        </template>
        <div class="row m-0 h-100 tab-content-media">
          <div class="col">
            <div class="row">
              <div class="col col-file" v-for="file in otherFiles" :key="file._id"
                   @click="selectFile(file)" :class="{ 'selected': selectedFileId === file._id }">
                <div class="delete-btn" @click="confirmDeleteFile(file)">
                  <font-awesome-icon icon="times"></font-awesome-icon>
                </div>
                <span class="text-box">{{file.originalName}}</span>
              </div>
            </div>
            <div class="center-message" v-if="loading">
              <b-spinner variant="primary" label="Spinning"></b-spinner>
            </div>
            <div class="center-message"  v-else-if="!otherFiles || otherFiles.length === 0">
              No data
            </div>
          </div>
        </div>
      </bs-tab>
      <bs-tab>
        <template v-slot:title>
          <div class="tab-title">
            <em class="icon mi mi-cloud-upload"></em>
            <span class="tab-title-text">Upload/URL</span>
          </div>
        </template>
        <div class="tab-content-upload" :class="{'disable-pointer': uploading }">
          <div class="form-label">URL</div>
          <div class="row m-0 mb-2">
            <div class="col p-0">
              <input class="input" placeholder="Paste an URL here" v-model="urlInput">
            </div>
          </div>
          <div class="row m-0 h-100">
            <div class="col p-0">
              <vue-dropzone id="media-dropzone" :options="dropzoneOptions" ref="media-dropzone"
                            v-on:vdropzone-file-added="onFileAdded"
                            v-on:vdropzone-error="onUploadError"
                            v-on:vdropzone-success="onUploadSuccess"
              ></vue-dropzone>
            </div>
          </div>
        </div>
        <div class="tab-content-upload-loading" v-if="uploading">
          <b-spinner variant="white" label="Spinning"></b-spinner>
        </div>
      </bs-tab>
    </bs-tabs>
  </div>
</template>
<script>
import { BTabs, BTab, BSpinner } from 'bootstrap-vue';
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import alice from '../../alice-api';

const ALICE_UPLOAD_URL = alice.uploadUrl;
const ID_SELECTOR = '_id';

export default {
  name: 'media-library-content',
  components: {
    'bs-tabs': BTabs,
    'bs-tab': BTab,
    'b-spinner': BSpinner,
    'vue-dropzone': vue2Dropzone,
  },
  data() {
    return {
      selectedTab: 4,
      loading: false,
      loadingMore: false,
      imageFiles: [],
      videoFiles: [],
      audioFiles: [],
      otherFiles: [],
      dropzonePrevFile: null,
      dropzoneOptions: {
        maxFiles: 1,
        url: ALICE_UPLOAD_URL,
        maxFilesize: 10,
        dictDefaultMessage: "<span class='custom-upload-text'>Choose media to upload</span>",
      },
      urlInput: '',
      selectedFile: null,
      uploading: false,
      currentPage: 1,
      pagingSize: 10,
      pagingData: {},
    };
  },
  watch: {
    selectedTab(newVal) {
      // Reset select state
      this.urlInput = '';
      this.selectFile(null);
      switch (newVal) {
        case 0: return this.loadFileList('IMAGE', false);
        case 1: return this.loadFileList('VIDEO', false);
        case 2: return this.loadFileList('AUDIO', false);
        case 3: return this.loadFileList('OTHERS', false);
        default: return false;
      }
    },
    urlInput(val) {
      // Check valid
      if (val) {
        this.$emit('selected', {
          type: 'others',
          result: {
            url: val,
          },
        });
      }
    },
  },
  methods: {
    async loadFileList(type, append) {
      // console.log('Load file list', type, append);
      if (append) {
        this.loadingMore = true;
      } else {
        this.currentPage = 1;
        this.loading = true;
      }
      try {
        const result = await alice.listFile({
          page: this.currentPage, size: this.pagingSize, type,
        });
        if (result && result.data && result.data.data && result.data.data.result) {
          // console.log(result);
          const d = result.data.data.result;
          this.pagingData = result.data.data.paging;
          if (append) {
            if (type === 'IMAGE') this.imageFiles = this.getNewAppendData(this.imageFiles, d);
            if (type === 'VIDEO') this.videoFiles = this.getNewAppendData(this.videoFiles, d);
            if (type === 'AUDIO') this.audioFiles = this.getNewAppendData(this.audioFiles, d);
            if (type === 'OTHERS') this.otherFiles = this.getNewAppendData(this.otherFiles, d);
          } else {
            if (type === 'IMAGE') this.imageFiles = d;
            if (type === 'VIDEO') this.videoFiles = d;
            if (type === 'AUDIO') this.audioFiles = d;
            if (type === 'OTHERS') this.otherFiles = d;
          }
        }
      } catch (e) {
        // console.log('Error', e);
      } finally {
        this.loading = false;
        this.loadingMore = false;
      }
    },
    reloadCurrentTab() {
      this.loadFileList(this.currentTabType, false);
    },
    loadMore() {
      this.currentPage += 1;
      this.loadFileList(this.currentTabType, true);
    },
    getNewAppendData(oldData, newData) {
      return [...oldData, ...newData];
    },
    getBackgroundImage(url) {
      return {
        backgroundImage: `url(${url})`,
      };
    },
    onFileAdded() {
      this.uploading = true;
      if (this.dropzonePrevFile) {
        this.$refs['media-dropzone'].removeFile(this.dropzonePrevFile);
      }
    },
    async onUploadError(file, message) {
      this.uploading = false;
      if (message.indexOf('upload any more files') === -1) {
        // console.log(message, xhr);
        const m = `Upload failed, ${message || 'Unknown error occurred'}`;
        this.$refs['media-dropzone'].removeAllFiles();
        if (this.$buefy.toast) {
          // Remove this for modular
          this.$buefy.toast.open({
            type: 'is-danger',
            message: m,
            position: 'is-bottom',
            duration: 5000,
          });
        }
      } else {
        // console.warn('Max file ...');
      }
    },
    async onUploadSuccess(file, response) {
      this.dropzonePrevFile = file;
      this.getInfoUntilDone(response.data.id, 3000, this.finishUploadProcess);
    },
    async getInfoUntilDone(id, timeout = 3000, callback) {
      // console.log('GET INFO', id);
      const response = await alice.getFileInfo(id);
      // console.log(response);
      if (response && response.data
        && response.data.data
        && response.data.data.progress
        && response.data.data.progress.status) {
        if (response.data.data.progress.status === 'finished') {
          return callback(null, response.data.data);
        } if (response.data.data.progress.status === 'error') {
          return callback(true, response.data.data);
        }
      }
      return setTimeout(() => {
        this.getInfoUntilDone(id, timeout, callback);
      }, 3000);
    },
    async finishUploadProcess(error, obj) {
      if (error) {
        // console.log('ERROR', error, obj);
        try {
          await alice.deleteFile(obj[ID_SELECTOR]);
        } catch (e) {
          // console.log('Cannot delete file', obj[ID_SELECTOR], e);
        }
        this.onUploadError(null, null, null);
      } else {
        // console.log('DONE', obj);
        this.selectFile(obj);
      }
      this.uploading = false;
      // Set select file
    },
    selectFile(file) {
      this.urlInput = '';
      if (file && file.result.url) {
        this.selectedFile = file;
      } else {
        this.selectedFile = null;
      }
      this.$emit('selected', this.selectedFile);
    },
    confirmDeleteFile(file) {
      this.$bvModal.msgBoxConfirm(`Are you sure to delete this file "${file.originalName}"`, {
        title: 'Please Confirm',
        size: 'sm',
        modalClass: 'fix-modal',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'Yes',
        cancelTitle: 'No',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true,
      }).then((value) => {
        if (value) {
          this.deleteFile(file[ID_SELECTOR]);
        }
      }).catch(() => {
        // console.log('Confirm err', err);
      });
    },
    async deleteFile(id) {
      try {
        await alice.deleteFile(id);
        this.selectFile(null);
      } catch (e) {
        // console.log(e);
      } finally {
        // Reload
        this.reloadCurrentTab();
      }
    },
  },
  computed: {
    currentTabType() {
      switch (this.selectedTab) {
        case 0: return 'IMAGE';
        case 1: return 'VIDEO';
        case 2: return 'AUDIO';
        case 3: return 'OTHERS';
        default: return false;
      }
    },
    selectedFileId() {
      if (this.selectedFile && this.selectedFile[ID_SELECTOR]) {
        return this.selectedFile[ID_SELECTOR];
      }
      return '';
    },
    totalPage() {
      if (this.pagingData && this.pagingData.totalPage) {
        return this.pagingData.totalPage;
      }
      return 0;
    },
    remainingItem() {
      if (this.pagingData && this.pagingData.totalCount) {
        return this.pagingData.totalCount - (this.currentPage * this.pagingSize);
      }
      return '...';
    },
  },
};
</script>
<style lang="scss">
  .media-lib-content {
    border-top: 1px solid #ddd;
    border-bottom: 1px solid #ddd;
    .tabs {
      margin: 0;
    }
    .ml-tab-content {
      min-height: 380px;
      max-height: 380px;
      overflow-x: hidden;
      overflow-y: auto;
      padding: 0;
      position: relative;
      .form-label {
        font-size: 13px;
      }
      .tab-content-media {
        padding: 20px 0 20px 20px;
      }
      .disable-pointer {
        pointer-events: none;
      }
      .tab-content-upload {
        padding: 20px;
        height: 100%;
        display: flex;
        flex-direction: column;
      }
      .tab-content-upload-loading {
        background-color: rgba(100,100,100,0.3);
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        pointer-events: none;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 100;
      }
    }
    .ml-media-tabs {
      background-color: #fafafa;
      padding: 0;
      box-shadow: inset -1px 0 0 0 #ddd;
      .nav-tabs {
        border: none;
      }
      .nav-item {
        width: 180px;
      }
      .nav-link {
        justify-content: start;
        border-width: 0 0 0 5px;
      }
      .tab-title {
        font-weight: bold;
        color: #999;
        font-size: 13px;
        padding: 4px;
        .tab-title-text {
          margin-left: 10px;
          text-align: left;
        }
      }
      .ml-active-nav {
        border-color: #0288D1;
        .tab-title-text, .icon {
          color: #0288D1;
        }
      }
    }
    .ml-active-tab {
      display: flex;
      flex-direction: column;
      height: 100%;
    }
    .center-message {
      display: flex;
      height: 100%;
      color: #999;
      justify-content: center;
      align-items: center;
    }
    .col-img, .col-file {
      position: relative;
      display: flex;
      flex: 0 0 110px;
      padding: 0;
      margin: 0 20px 20px 0;
      border: 2px solid #fff;
      overflow: hidden;
      align-items: flex-end;
      &.selected {
        border: 2px solid #0288d1;
        font-weight: bold;
      }
      .text-box {
        font-size: 13px;
        padding: 10px;
        text-wrap: normal;
        white-space: normal;
      }
      .preview {
        min-width: 110px;
        max-width: 110px;
        min-height: 110px;
        max-height: 110px;
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }
      .delete-btn {
        position: absolute;
        top: 0;
        right: 0;
        border-radius: 0 0 0 20px;
        width: 20px;
        height: 20px;
        font-size: 13px;
        text-align: right;
        color: #ff5f5d;
        background-color: rgba(100,100,100,0.3);
        line-height: 15px;
        padding-top: 1px;
        padding-right: 3px;
        cursor: pointer;
        &:hover {
          background-color: #fff;
        }
      }
    }
    .col-file {
      min-width: 120px;
      max-width: 120px;
      min-height: 120px;
      max-height: 120px;
      background-color: #eee;
    }
    .load-more {
      cursor: pointer;
      text-align: center;
      color: #3788d8;
      font-size: 12px;
      text-decoration: underline;
    }
    .loading-more {
      color: #ddd;
      text-align: center;
      font-size: 12px;
    }
  }
  #media-dropzone {
    border: 2px dashed #ddd;
    height: 100%;
    overflow: auto;
    .custom-upload-text {
      border-radius: 3px;
      background-color: #0288D1;
      color: #fff;
      font-size: 13px;
      padding: 10px;
    }
    .dz-message {
      margin: 6em 0;
    }
  }
</style>
